<template>
    <div class="flex flex-nowrap space-x-1">
        <div class="flex grow flex-col p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800">
            <div class="flex items-center justify-between pb-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                    <h3 class="text-base font-normal text-gray-500 dark:text-gray-400">
                        Thống kê thời gian thực
                    </h3>
                    <span class="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                        {{ getLabel() }}
                    </span>
                </div>
            </div>
            <hts-analytics-chart
                type="pie"
                :labels="labels"
                :series="series"
                height="200" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import statistic from '~/composables/api-url/statistic'
import { $lodash } from '#imports'

const props = defineProps({
  module: {
    type: String,
    required: true
  }
})

const { module } = toRefs(props)

const dataReport = ref<{ [key: string]: any }>({})
const getStatistic = async () => {
  const api = $url.statistic.getStatistic
  const res = await $api(api, {
    uriParams: {
      CLASS: module.value
    },
    params: {
      typeReport: 'status'
    }
  })
  const resData: any = res?.data.value
  if (resData?.success) {
    dataReport.value = resData.data
    editDataReportChart()
  }
  return null
}

const labels = ref<Array<string>>([])
const series = ref<Array<number>>([])

const editDataReportChart = () => {
  const listStatus = getStatusModule[module.value]
  const typeStatus = $lodash.map(dataReport.value?.status, '_id')
  series.value = $lodash.map(dataReport.value?.status, 'count')
  const labelStatus: Array<string> = []

  typeStatus.forEach((t: number | null) => {
    labelStatus.push(!$lodash.isNil(t) ? listStatus[String(t)] : 'Unknown')
  })
  labels.value = labelStatus
}

const getLabel = () => {
  switch (module.value) {
  case 'vehicles':
    return 'Trạng thái xe'
  case 'driver':
    return 'Trạng thái tài xế'
  case 'order':
    return 'Trạng thái đơn hàng'
  case 'quote':
    return 'Trạng thái báo giá'
  case 'quoteRequest':
    return 'Trạng thái yêu cầu báo giá'
  default:
    return 'Unknow'
  }
}

const getStatusModule: { [key: string]: any } = {
  vehicles: {
    1: $t('labels.readyShip'),
    '-1': $t('labels.vehicleModule.notReady')
  },
  driver: {
    0: $t('labels.notReadyYet'),
    1: $t('labels.conditionallyReady'),
    2: $t('labels.ready')
  },
  order: {
    0: 'pending',
    1: 'active',
    2: 'complete'
  },
  quote: {
    0: $t('labels.init'),
    1: $t('labels.send'),
    2: $t('labels.orderCreated'),
    3: $t('labels.cancel')
  },
  quoteRequest: {
    0: $t('labels.draft'),
    1: $t('labels.waitPrice'),
    2: $t('labels.quoteCreated'),
    3: $t('labels.cancel')
  }
}
const intervalId = ref()
onBeforeMount(async () => {
  await getStatistic()
  intervalId.value = setInterval(async () => {
    await getStatistic()
  }, 60000)
})

onUnmounted(() => {
  clearInterval(intervalId.value)
})
</script>

<style scoped></style>
